export default {
	tenantId: "fiLife_uat",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "filife--uat"
	}
}
